import { GET_MINIBAR_COUNT_SUCCESS } from "../types";

export const setMinibarCount = (data) => {
  return {
    type: GET_MINIBAR_COUNT_SUCCESS,
    payload: data,
  };
};
